export enum NewsAndEventsHeaderEnums {
  FEATURED_STORIES = 'FEATURED STORIES',
  NEWS = 'NEWS',
  EVENTS = 'EVENTS'
}

export enum NewsAndEventsFilterEnums {
  FEATURED_STORIES = 'stories',
  NEWS = 'news',
  EVENTS = 'events'
}
